<div mat-dialog-content>
  <ng-container *ngIf="data.showSpinner === true">
    <app-icon
      *ngIf="data.customIcon !== undefined && data.lightColour === true"
      [iconSize]="data.spinnerSize"
      class="cos-padding-3"
    >
      <ng-container
        *ngIf="
          data.customIcon !== undefined &&
          data.customIcon === '' &&
          data.matIcon !== undefined &&
          data.matIcon === ''
        "
      >
        lspin
      </ng-container>
      <ng-container
        *ngIf="data.customIcon !== undefined && data.customIcon !== ''"
      >
        {{ data.customIcon }}
      </ng-container>
    </app-icon>
    <ng-container *ngIf="data.matIcon !== undefined && data.matIcon !== ''">
      <div
        fxLayoutAlign="center center"
        fxFlexAlign="center"
        class="cos-fluid-width cos-fluid-height cos-padding-4"
      >
        <mat-icon color="primary" class="cos-large-icon">
          {{ data.matIcon }}
        </mat-icon>
      </div>
    </ng-container>
    <app-icon
      *ngIf="data.customIcon !== undefined && data.lightColour === false"
      [iconSize]="data.spinnerSize"
      class="cos-padding-3"
    >
      <ng-container *ngIf="data.customIcon === ''"> spin </ng-container>
      <ng-container *ngIf="data.customIcon !== ''">
        {{ data.customIcon }}
      </ng-container>
    </app-icon>
  </ng-container>
  <div
    [ngClass]="textAlign"
    *ngIf="data.titleText !== undefined && data.titleText !== ''"
    class="cos-margin-1 cos-no-margin-top cos-no-margin-left cos-no-margin-right cos-body-0"
  >
    <b>
      {{ data.titleText | translate }}
    </b>
  </div>
  <div
    *ngIf="data.titleText === undefined || data.titleText === ''"
    [ngClass]="textAlign"
    class="cos-margin-1 cos-no-margin-top cos-no-margin-left cos-no-margin-right"
  >
    {{ data.message | translate }}
  </div>
  <div
    [ngClass]="textAlign"
    *ngIf="data.subText !== ''"
    class="cos-margin-4 cos-no-margin-top cos-no-margin-left cos-no-margin-right"
  >
    {{ data.subText | translate }}
  </div>
</div>
<div
  mat-dialog-actions
  [fxLayoutAlign]="data.textAlign === 'center' ? 'center center' : 'end center'"
>
  <ng-container *ngIf="data.showYesNo !== undefined && data.showYesNo === true">
    <div fxFlex fxLayout="row">
      <button
        (click)="yesNoPressed(false)"
        fxFlex
        mat-button
        class="cos-body-4"
      >
        <b>
          {{ "BUTTON.CANCEL" | translate }}
        </b>
      </button>
      <button (click)="yesNoPressed(true)" fxFlex mat-button class="cos-body-4">
        <b>
          {{ "BUTTON.PROCEED" | translate }}
        </b>
      </button>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      data.showYesNo === undefined ||
      (data.showYesNo !== undefined && data.showYesNo === false)
    "
  >
    <button fxFlex (click)="goToLink()" mat-button class="cos-body-4">
      <b>
        {{
          (data.buttonTitle !== undefined && data.buttonTitle !== ""
            ? data.buttonTitle
            : "BUTTON.CLOSE"
          ) | translate
        }}
      </b>
    </button>
  </ng-container>
</div>
